module.exports = __webpack_public_path__ + "media/images/nooklyn-logo-89a6ddfb.svg";